import styled from 'styled-components'

// eslint-disable-next-line import/prefer-default-export
export const UploadResumeWrapper = styled.article`
  width: 100%;
  background-color: #faf9f8;
  padding: 15px;
  border-radius: 25px;
  .ant-upload-text {
    font-size: 15px !important;
  }

  .resume-uploaded {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    p {
      margin-top: 20px;
      font-size: 14px;
    }
  }

  .dropzone-content p {
    text-align: center;
    cursor: pointer;
    text-decoration: underline;
  }

  .container-upload {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 7px;
  }
`
